// @flow
import { kebabCase } from 'lodash';
import React, { type Element, type Node } from 'react';
import { Col, Row, Button, ButtonToolbar } from 'angieslist-react-components';
import { Track } from 'angieslist-app-platform';
import './SingleCard.scss';

type Props = {
  headerIcon?: any,
  headerTitle?: string,
  headerSubtitle?: string,
  ctaText: string,
  ctaLink?: string,
  metricValue?: string,
  metricLabel?: Node,
  buttonProps?: any,
  modalContent?: Node,
  customWidth?: number,
  boldHeaderTitle?: boolean,
};


const SingleCard = ({
  headerIcon, headerTitle, ctaText, ctaLink, metricValue, metricLabel, buttonProps, modalContent,
  customWidth, headerSubtitle, boldHeaderTitle,
}: Props): Element<"div"> => {
  const iconConcatenated = headerIcon ? `icon icon-${headerIcon} icon-lg` : '';
  const noHeaderIcon = iconConcatenated === '';
  const buttonIdConcatenated = `card-cta-button-${kebabCase(headerTitle)}`;
  const width = customWidth || 70;
  return (
    <div className="single-card">
      <div className="card-container">
        <Row className="card-body-padding">
          <Choose>
            <When condition={headerSubtitle}>
              <Col xs={8} className="header-title">
                <i className={iconConcatenated} />&nbsp;&nbsp;
                <span className={noHeaderIcon ? 'header-title-copy-bold' : 'header-title-copy'}>
                  {headerTitle}
                </span>
              </Col>
              <Col xs={4} className="header-sub-title">
                {headerSubtitle}
              </Col>
            </When>
            <Otherwise>
              <Col xs={12} className="header-title">
                <i className={iconConcatenated} />&nbsp;&nbsp;<span className={boldHeaderTitle ? 'header-title-copy-bold' : 'header-title-copy'}>{headerTitle}</span>
              </Col>
            </Otherwise>
          </Choose>
        </Row>
        <div className="card-body-padding card-body">
          <Row>
            <div className="metric-section">
              <Choose>
                <When condition={metricLabel && !metricValue && !customWidth}>
                  <p style={{ width: '70%', margin: '1em auto' }}>{metricLabel}</p>
                </When>
                <When condition={metricLabel && !metricValue && customWidth}>
                  <div style={{ width: `${width}%`, margin: '1em auto' }}>{metricLabel}</div>
                </When>
                <Otherwise>
                  <div className="metric-value">{metricValue}</div>
                  <div className="metric-label">{metricLabel}</div>
                </Otherwise>
              </Choose>
            </div>
          </Row>
        </div>

        <Choose>
          <When condition={modalContent}>
            {modalContent}
          </When>
          <Otherwise>
            <If condition={ctaLink}>
              <ButtonToolbar className="cta-toolbar">
                <Track>
                  <Button
                    href={ctaLink}
                    id={buttonIdConcatenated}
                    bsStyle="link"
                    bsSize="small"
                    className="cta-button text-info"
                    ghost
                    {...buttonProps}
                  >
                    {ctaText}
                  </Button>
                </Track>
              </ButtonToolbar>
            </If>
          </Otherwise>
        </Choose>

      </div>
    </div>
  );
};

export default(SingleCard);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/Card/SingleCard.js